import { useCallback, useRef, useState } from "react";

function useContainerWidth<T extends HTMLElement = HTMLDivElement>() {
	const [containerWidth, setContainerWidth] = useState<number>(0);
	const observerRef = useRef<ResizeObserver | null>(null);

	const containerRef = useCallback((node: T | null) => {
		if (observerRef.current) {
			observerRef.current.disconnect();
		}
		if (node) {
			// Use ResizeObserver to avoid forced reflows
			observerRef.current = new ResizeObserver(entries => {
				// Simplified: just use the first entry's contentBoxSize
				const entry = entries[0];
				if (entry?.contentBoxSize?.[0]) {
					setContainerWidth(entry.contentBoxSize[0].inlineSize);
				}
			});
			observerRef.current.observe(node);
		}
	}, []);

	return { containerRef, containerWidth };
}

export default useContainerWidth;
